// Client owner (district), #4320 — the MUI picker used by the row's Assign
// popover and the Create work item form. (The to-do form's native-input twin
// is ClientOwnerInput in CS/ClientOverview/TodoForm.js; both suggest from the
// same useClientContacts.)
//
// Suggests the client's Executive sponsor, Champions and Key contacts from its
// success profile; anything can be typed. Informational only: Nexus never
// emails or nudges this person, and the helper text says so.

import { Typography } from '@mui/material';
import PersonField from './PersonField';
import { useClientContacts, CLIENT_OWNER_LABEL } from '../../services/clientOwners';

export const CLIENT_OWNER_HINT = 'For the team’s information only — Nexus never emails or nudges them.';

export default function ClientOwnerField({ clientId, value, onChange, unreadable = false, sx, showLabel = true }) {
    const contacts = useClientContacts(clientId);
    const names = contacts.map((c) => c.name);
    return (
        <>
            {showLabel && (
                <Typography sx={{ fontSize: 11, fontWeight: 600, mb: 0.25 }}>{CLIENT_OWNER_LABEL}</Typography>
            )}
            {unreadable ? (
                <Typography sx={{ fontSize: 11.5, color: '#b45309', mb: 1, ...sx }}>
                    Couldn’t read the client owner, so it can’t be changed here right now.
                </Typography>
            ) : (
                <PersonField value={value} onChange={(v) => onChange(v || '')} options={names}
                    people={[]} inputAriaLabel={CLIENT_OWNER_LABEL}
                    placeholder={names.length ? 'Pick a district contact or type a name' : 'Name of the district person'}
                    helperText={CLIENT_OWNER_HINT}
                    FormHelperTextProps={{ sx: { fontSize: 10.5, mx: 0 } }} sx={sx} />
            )}
        </>
    );
}
